import {
  Component,
  OnInit,
  AfterContentInit,
  ViewChild,
  ElementRef,
} from "@angular/core";

import {
  FormGroup,
  Validators,
  FormControl,
  FormBuilder,
} from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { EquipamentoService } from "src/app/services/equipamento.service";
import { LocalService } from "src/app/services/local.service";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { FabricanteComponent } from "../cadastros/fabricante/fabricante.component";
import { FabricantedeService } from "src/app/pages/cadastros/services/fabricante.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import {
  TipoDeEquipamento,
  ClasseEquipamento,
  Local,
  GrupoLocalNivel1,
} from "../domain/domain.model";
import { ClasseEquipamentoService } from "src/app/services/classe-equipamento.service";
import { TipoEquipamentoService } from "src/app/services/tipo-equipamento.service";
import { CommandResult } from "../domain/commandResult";
import { GrupoLocalNivelService } from "src/app/services/grupo-local-nivel.service";
import { APP_SETTINGS } from "src/environments/environment";

///equipamento
@Component({
  selector: "app-equipamento",
  templateUrl: "./equipamento.component.html",
  styleUrls: ["./equipamento.component.scss"],
  providers: [
    EquipamentoService,
    LocalService,
    CentroCustoService,
    FabricantedeService,
  ],
})
export class EquipamentoComponent implements OnInit, AfterContentInit {
  constructor(
    private equipamentoService: EquipamentoService,
    private localService: LocalService,
    // private centroCustoService: CentroCustoService,
    private fabricanteService: FabricantedeService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private usuarioService: UsuarioService,
    private classeEquipamentoService: ClasseEquipamentoService,
    private tipoEquipamentoService: TipoEquipamentoService,
    private formBuilder: FormBuilder,
    private grupoLocalNivelService: GrupoLocalNivelService
  ) {}

  public cadastrados: any[] = [];
  public locais: Local[] = [];
  // public centrocustos: any[] = [];
  public fabricantes: any[] = [];
  public substacoesOrigem: any[] = [];
  public substacoesDestino: any[] = [];

  public niveis1: GrupoLocalNivel1[] = [];
  public cadastradosPorNivel: any[] = [];

  public tiposEquipamentos: TipoDeEquipamento[] = [];
  public classesEquipamento: ClasseEquipamento[] = [];
  public tipoEquipamentoDescricao = "";

  public maskAno = [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
  public maskClasse = [/[0-9]/];

  public form: FormGroup = null;

  public isEditing = false;
  public isProcessing = false;
  public isFiltered = false;
  public isLoading = false;
  public enableFieldsForm = true;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  public filtredByTipo = 0;
  public filtredByParameter = "";

  public autorizacoes: UsuarioAutorizacoes;

  public tiposEquipamentosComboBox: TipoDeEquipamento[] = [];

  // @ViewChild('centroCustoIdReadonly') centroCustoIdReadonly: ElementRef;

  shouldOpenModal: boolean = null;

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("equipamento");
  }

  ngOnInit() {
    // this.search(this.filtredByParameter, this.filtredByTipo, true); // carrega lista de já cadastrados
    this.resetForm(); // instancia o formulário utilizado (formGroup)
    // this.getLocais();
    this.getFabricantes();
    this.getSubstacoesOrigem();
    this.getSubstacoesDestino();
    this.getTiposEquipamentos();
    this.getClassesEquipamentos();
    this.getAllGrupoLocalNivel1();
    this.getEquipamentosVisiveisNoSistema();
  }

  openModal() {
    this.shouldOpenModal = !this.shouldOpenModal;
  }

  getAllGrupoLocalNivel1() {
    this.grupoLocalNivelService
      .getAllGrupoLocalNivel1()
      .subscribe((response: GrupoLocalNivel1[]) => {
        this.niveis1 = response;
      });
  }

  getLocaisByGrupoLocalNivelId(
    grupoLocalNivel1Id: number,
    localid: number = null
  ) {
    this.locais = [];

    if (grupoLocalNivel1Id > 0) {
      this.localService
        .getLocaisByGrupoLocalNivelId(grupoLocalNivel1Id)
        .subscribe((response: Local[]) => {
          this.locais = response;

          if (localid != null) {
            this.form.get("localId").setValue(localid);
          } else {
            if (this.locais.length === 1) {
              this.form.get("localId").setValue(this.locais[0].id);
            } else {
              this.form.get("localId").setValue("");
            }
          }
        });
    }
  }

  private getTiposEquipamentos() {
    this.tipoEquipamentoService
      .getAll()
      .subscribe((response: TipoDeEquipamento[]) => {
        this.tiposEquipamentos = response;
      });
  }

  private getClassesEquipamentos() {
    this.classeEquipamentoService
      .getAll()
      .subscribe((response: ClasseEquipamento[]) => {
        this.classesEquipamento = response;
      });
  }

  private getFabricantes() {
    this.fabricanteService
      .list()
      .subscribe((response) => (this.fabricantes = response));
  }

  private getSubstacoesOrigem() {
    this.localService
      .listSubstacoes()
      .subscribe((response) => (this.substacoesOrigem = response));
  }

  private getSubstacoesDestino() {
    this.localService
      .listSubstacoes()
      .subscribe((response) => (this.substacoesDestino = response));
  }

  public resetForm(): void {
    this.form = this.formBuilder.group({
      id: [0],
      tipoEquipamentoId: [
        APP_SETTINGS.tipoEquipamentoPadrao,
        Validators.required,
      ],
      classeEquipamentoId: ["", [Validators.required]],
      nome: [null, [Validators.required, Validators.maxLength(20)]],
      descricao: [
        { value: null, disabled: this.enableFieldsForm },
        [Validators.required, Validators.maxLength(100)],
      ],
      util: [
        { value: null, disabled: this.enableFieldsForm },
        [Validators.maxLength(60)],
      ],
      modelo: [
        { value: null, disabled: this.enableFieldsForm },
        [Validators.maxLength(40)],
      ],
      numeroSerie: [
        { value: null, disabled: this.enableFieldsForm },
        [Validators.maxLength(15)],
      ],
      numeroPatrimonio: [
        { value: null, disabled: this.enableFieldsForm },
        [Validators.maxLength(15)],
      ],
      anoFabricacao: [
        { value: null, disabled: this.enableFieldsForm },
        [Validators.maxLength(4)],
      ],
      anoInstalacao: [null, [Validators.maxLength(4)]],
      comprimento: [null, [Validators.maxLength(13)]],
      largura: [null, [Validators.maxLength(13)]],
      altura: [null, [Validators.maxLength(13)]],
      localId: ["", [Validators.required]],
      fabricanteId: ["", [Validators.required]],
      cabo: [null, [Validators.maxLength(7)]],
      tipo: [null, [Validators.maxLength(15)]],
      subestacaoIdOrigem: [null],
      subestacaoIdDestino: [null],
      qtde: [null, [Validators.maxLength(7), Validators.pattern("^[0-9]*$")]],
      numero: [null, [Validators.maxLength(7), Validators.pattern("^[0-9]*$")]],
      potencia: [null, [Validators.maxLength(10)]],
      vp: [null, [Validators.maxLength(7)]],
      vs: [null, [Validators.maxLength(7)]],
      taps: [null, [Validators.maxLength(15)]],
      tombamento: [null, [Validators.maxLength(12)]],
      classe: [
        null,
        [
          Validators.pattern("^[0-9]*$"),
          Validators.required,
          Validators.max(5),
          Validators.min(1),
        ],
      ],

      criticidade: [""],
      especificacao: [null, [Validators.maxLength(100)]],
      potenciaAR: [null, [Validators.maxLength(10)]],
      contorno: [0, [Validators.maxLength(20)]],
      grupoLocalNivel1Id: [""],
    });

    this.setEnabledFieldsForm(false);
  }

  setEnabledFieldsForm(enableForm: boolean) {
    if (enableForm) {
      this.form.controls.nome.enable();
      this.form.controls.descricao.enable();
      this.form.controls.util.enable();
      this.form.controls.modelo.enable();
      this.form.controls.numeroSerie.enable();
      this.form.controls.numeroPatrimonio.enable();
      this.form.controls.anoFabricacao.enable();
      this.form.controls.anoInstalacao.enable();
      this.form.controls.comprimento.enable();
      this.form.controls.largura.enable();
      this.form.controls.altura.enable();
      this.form.controls.localId.enable();
      this.form.controls.fabricanteId.enable();
      this.form.controls.cabo.enable();
      this.form.controls.tipo.enable();
      this.form.controls.subestacaoIdOrigem.enable();
      this.form.controls.subestacaoIdDestino.enable();
      this.form.controls.qtde.enable();
      this.form.controls.numero.enable();
      this.form.controls.potencia.enable();
      this.form.controls.vp.enable();
      this.form.controls.vs.enable();
      this.form.controls.taps.enable();
      this.form.controls.tombamento.enable();
      this.form.controls.classe.enable();
      this.form.controls.criticidade.enable();
      this.form.controls.especificacao.enable();
      this.form.controls.potenciaAR.enable();
      this.form.controls.contorno.enable();
      this.form.controls.grupoLocalNivel1Id.enable();
    } else {
      this.form.controls.nome.disable();
      this.form.controls.descricao.disable();
      this.form.controls.util.disable();
      this.form.controls.modelo.disable();
      this.form.controls.numeroSerie.disable();
      this.form.controls.numeroPatrimonio.disable();
      this.form.controls.anoFabricacao.disable();
      this.form.controls.anoInstalacao.disable();
      this.form.controls.comprimento.disable();
      this.form.controls.largura.disable();
      this.form.controls.altura.disable();
      this.form.controls.localId.disable();
      this.form.controls.fabricanteId.disable();
      this.form.controls.cabo.disable();
      this.form.controls.tipo.disable();

      this.form.controls.subestacaoIdOrigem.disable();
      this.form.controls.subestacaoIdDestino.disable();
      this.form.controls.qtde.disable();
      this.form.controls.numero.disable();
      this.form.controls.potencia.disable();
      this.form.controls.vp.disable();
      this.form.controls.vs.disable();
      this.form.controls.taps.disable();
      this.form.controls.tombamento.disable();
      this.form.controls.classe.disable();
      this.form.controls.criticidade.disable();
      this.form.controls.especificacao.disable();
      this.form.controls.potenciaAR.disable();
      this.form.controls.contorno.disable();
      this.form.controls.grupoLocalNivel1Id.disable();
    }
  }

  public reset(): void {
    this.isEditing = false;
    this.isProcessing = false;
    this.isLoading = false;

    this.setEnabledFieldsForm(false);

    this.resetForm();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  public showEquipamento(equipamento: any): void {
    this.form.patchValue({
      id: equipamento.id,
      tipoEquipamentoId: equipamento.tipoDeEquipamentoId,
      nome: equipamento.nome,
      descricao: equipamento.descricao,
      util: equipamento.util,
      modelo: equipamento.modelo,
      numeroSerie: equipamento.numeroSerie,
      numeroPatrimonio: equipamento.numeroPatrimonio,
      anoFabricacao: equipamento.anoFabricacao,
      anoInstalacao: equipamento.anoInstalacao,
      comprimento: equipamento.comprimento,
      largura: equipamento.largura,
      altura: equipamento.altura,
      fabricanteId: equipamento.fabricanteId,
      cabo: equipamento.cabo,
      tipo: equipamento.tipo,
      subestacaoIdOrigem: equipamento.subestacaoIdOrigem,
      subestacaoIdDestino: equipamento.subestacaoIdDestino,
      qtde: equipamento.qtde,
      numero: equipamento.numero,
      potencia: equipamento.potencia,
      vp: equipamento.vp,
      vs: equipamento.vs,
      taps: equipamento.taps,
      tombamento: equipamento.tombamento,
      classe: equipamento.classe,
      classeEquipamentoId: equipamento.classeEquipamentoId,
      criticidade: equipamento.criticidade,
      especificacao: equipamento.especificacao,
      potenciaAR: equipamento.potenciaAR,
      contorno: equipamento.contorno,
      grupoLocalNivel1Id: equipamento.local.grupoLocalNivel1.id,
    });

    this.getLocaisByGrupoLocalNivelId(
      equipamento.local.grupoLocalNivel1.id,
      equipamento.localId
    );
    this.setEnabledFieldsForm(true);
    this.isEditing = true;
  }

  public submit(): void {
    this.setEnabledFieldsForm(true);

    this.form.controls.descricao.enable();

    if (this.validForm()) {
      this.isProcessing = true;

      if (this.form.get("id").value === 0) {
        this.equipamentoService
          .nomeJaCadastrado(this.form.get("nome").value)
          .subscribe(
            (isUniqueNomeEquipamento: boolean) => {
              if (isUniqueNomeEquipamento) {
                if (this.form.get("numeroSerie").value !== "") {
                  this.equipamentoService
                    .numeroSerieJaCadastrada(this.form.get("numeroSerie").value)
                    .subscribe(
                      (isUniqueNumeroSerieEquipamento: boolean) => {
                        if (isUniqueNumeroSerieEquipamento) {
                          this.save();
                        } else {
                          this.form
                            .get("numeroSerie")
                            .setErrors({
                              isNotUniqueNumeroSerieEquipamento: true,
                            });
                          this.isProcessing = false;
                        }
                      },
                      (error: any) => {
                        this.showError(error);
                      }
                    );
                } else {
                  this.save();
                }
              } else {
                this.form
                  .get("nome")
                  .setErrors({ isNotUniqueNomeEquipamento: true });
                this.isProcessing = false;
              }
            },
            (error: any) => {
              this.showError(error);
            }
          );
      } else {
        this.save();
      }
    }
  }

  public validForm() {
    let valid = true;

    const anoAtual = new Date().getFullYear();
    const anoInstalacao = Number(this.form.get("anoInstalacao").value);
    const anoFabricacao = Number(this.form.get("anoFabricacao").value);

    if (isNaN(anoInstalacao)) {
      this.form.get("anoInstalacao").setErrors({ isInconsistent: true });
      valid = false;
    }

    if (isNaN(anoFabricacao)) {
      this.form.get("anoFabricacao").setErrors({ isInconsistent: true });
      valid = false;
    }

    if (anoFabricacao > 0 && anoInstalacao > 0) {
      if (anoFabricacao > anoAtual || anoFabricacao < 1900) {
        this.form.get("anoFabricacao").setErrors({ isInconsistent: true });
        valid = false;
      }

      if (
        anoInstalacao > anoAtual ||
        anoInstalacao < anoFabricacao ||
        anoInstalacao < 1900
      ) {
        this.form.get("anoInstalacao").setErrors({ isInconsistent: true });
        valid = false;
      }
    }

    return valid;
  }
  public save() {
    this.form.get("classeEquipamentoId").enable();

    this.equipamentoService.post(this.form.value).subscribe(
      (response: CommandResult) => {
        if (response.success === true) {
          this.toastr.success(response.message);
          this.reset();

          // this.search(this.filtredByParameter, this.filtredByTipo, true);
        } else {
          this.toastr.error(response.message);
        }
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false;
      },
      () => (this.isProcessing = false)
    );
  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) {
        this.voids.push("");
      }
    }
  }

  public showModalSm(modal: any) {
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  public showModalLg(modal: any) {
    this.modalService.open(modal, {
      windowClass: "lgModal",
      backdrop: "static",
    });
  }

  public delete(id: number, c: any): void {
    this.isProcessing = true;
    c("Close click");

    this.equipamentoService.delete(id).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.reset();
        // this.search(this.filtredByParameter, this.filtredByTipo, true);
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false;
      },
      () => (this.isProcessing = false)
    );
  }

  public showError(error: any) {
    // this.form.get('codigo').setErrors({ hasError: true });

    if (error.error.errors) {
      this.toastr.error(error.error.errors[0].message);
    } else {
      this.toastr.error("Ocorreu um erro no servidor");
    }

    this.isProcessing = false;
  }

  public clearValor() {
    this.form.get("valor").setValue(null);
  }

  changeTipoOrClasseEquipamento() {
    if (
      this.form.get("tipoEquipamentoId").value !== "" &&
      this.form.get("classeEquipamentoId").value !== ""
    ) {
      this.setEnabledFieldsForm(true);
    } else {
      this.setEnabledFieldsForm(false);
    }
  }

  getEquipamentosVisiveisNoSistema() {
    this.tipoEquipamentoService
      .getAll()
      .subscribe((response: TipoDeEquipamento[]) => {
        this.tiposEquipamentosComboBox = response;
      });
  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`
    );
  }
}
